import PropTypes from 'prop-types';

export const scribeDocumentBase = {
  docNo: PropTypes.number.isRequired,
  docVersionNo: PropTypes.number.isRequired,
  docModel: PropTypes.string.isRequired,
  docTitle: PropTypes.string.isRequired,
};

export const parentContainer = {
  parentContainer: PropTypes.shape(scribeDocumentBase).isRequired,
};
